import React from "react";
import t from "babel-plugin-yate/macro";

import Button from "./Button";
import Pagination from "./Pagination";
import { LendingRequestsListItem } from "./LendingRequestsListItem";

export const LendingRequestsList = ({
  accessType,
  currentUsername,
  handleCancelApplication,
  isLoading,
  onPageChange,
  pagination,
  requests,
}) => {
  if (isLoading || !requests) {
    return (
      <div className="table w-full border border-collapse text-12 bg-white rounded">
        <div className="table-row">
          <div className="table-cell">
            <div className="flex items-center justify-center relative min-h-200 text-20">
              <div className="spinner" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (requests.length === 0) {
    return (
      <div className="table w-full border border-collapse text-12 bg-white rounded">
        <div className="table-row">
          <div className="table-cell">
            <div className="flex items-center justify-center relative min-h-200 text-20">
              {t`No requests`}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="table w-full text-12 bg-white rounded border mb-8">
        <div className="table-row text-grey-darker-1">
          <div className="table-cell uppercase align-baseline px-2 py-4 border-b">
            {t`Details`}
          </div>
          <div className="table-cell uppercase align-baseline px-2 py-4 border-b">
            {t`Date`}
          </div>
          <div className="table-cell uppercase align-baseline px-2 py-4 border-b">
            {t`CNP`}
          </div>
          <div className="table-cell uppercase align-baseline px-1 py-4 border-b">
            {t`Telefon`}
          </div>
          <div className="table-cell uppercase align-baseline px-1 py-4 border-b">
            {t`Email`}
          </div>
          <div className="table-cell uppercase align-baseline px-1 py-4 border-b">
            {t`Contract`}
          </div>
          <div className="table-cell uppercase align-baseline px-2 py-4 border-b text-right">
            {t`Actions`}
          </div>
        </div>

        {requests.map((request) => (
          <div key={request.id} className="table-row">
            <LendingRequestsListItem data={request} />

            <div className="table-cell align-top pl-1 pr-2 py-4 border-b">
              <div className="flex justify-end">
                {!["rejected", "signed", "done", "canceled"].includes(
                  request.status,
                ) &&
                  accessType.some((type) =>
                    ["admin", "broker_agent"].includes(type),
                  ) &&
                  request.created_by === currentUsername && (
                    <Button
                      title={t`Cancel`}
                      onClick={() => handleCancelApplication(request.id)}
                    />
                  )}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="flex justify-end items-center">
        <Pagination
          items={pagination.items}
          totalPages={pagination.pages}
          currentPage={pagination.currentPage}
          gotoPage={onPageChange}
        />
      </div>
    </>
  );
};
